import React, { Fragment, useCallback, useState } from 'react'
import cn from 'classnames'
import { ButtonSelect } from './ButtonSelect'

function splitOnRegex(str, regex, callback) {
  const parts = str.split(regex)
  const matches = [...str.matchAll(regex)]
  const matchIndexes = {}
  return parts.flatMap((part, index) => {
    let match = matches[index]
    if (!match || index >= parts.length) return callback(part, index, null, null)
    match = match[0]
    if (!(match in matchIndexes)) matchIndexes[match] = -1
    matchIndexes[match]++
    return callback(part, index, match, matchIndexes[match])
  })
}

export function ProductCategorySentence({
  category,
  categories,
  onCategoryChange,
  attributeValues,
  onAttributeValueChange,
  onAttributeSelectorOpenChange,
}) {
  const { sentence, filter_groups } = category
  const sentenceText = sentence || `I'm looking for $`

  const [selectorOpen, _setSelectorOpen] = useState(false)
  const setSelectorOpen = useCallback((open) => {
    _setSelectorOpen(open)
    onAttributeSelectorOpenChange(open)
  })

  const sentenceParts = splitOnRegex(sentenceText, /[\$\^\n]/gm, (part, index, match, matchIndex) => {
    const text = !!part ? <span>{part}</span> : null
    switch (match) {
      case '\n':
        return [text, <br />]
      case '$':
        return [
          text,
          <ButtonSelect
            key={`categorySelector_${category.slug}`}
            options={categories.map((cat) => ({ value: cat.slug, text: cat.short_title || cat.title }))}
            value={category.slug}
            onChange={(categorySlug) => onCategoryChange(categorySlug)}
            onOpenChange={(open) => setSelectorOpen(open)}
          />,
        ]
      case '^':
        const filterGroup = filter_groups[matchIndex]
        if (!filterGroup || !filterGroup.categories || !filterGroup.categories.length) return [text]
        return [
          text,
          <ButtonSelect
            key={`attributeSelector_${filterGroup.slug}`}
            options={[
              { value: null, text: 'Any' },
              ...filterGroup.categories.map((cat) => ({ text: cat.title, value: cat.id })),
            ]}
            value={attributeValues[filterGroup.slug]}
            onChange={(attrVal) => onAttributeValueChange(filterGroup.slug, attrVal)}
            onOpenChange={(open) => setSelectorOpen(open)}
          />,
        ]
      default:
        return [text]
    }
  })

  return (
    <h2 className={cn('magic-sentence', { faded: selectorOpen }, 'display-title display-title-xl')}>
      {sentenceParts.map((part, i) => (
        <Fragment key={i} children={part} />
      ))}
    </h2>
  )
}
